import { Button, FormControl, OutlinedInput, InputLabel, Stack } from "@mui/material";
import React, { useState } from "react";
import Modal, { CommonModalProps, ModalContext } from "..";
import { ingestService } from "../../../Core/Api/services";
import { DbIngestConfigPackInfos } from "../../../Core/Api/Types/db-ingest-config-pack-infos";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

type CloseClbProps = {
  // confirm: boolean;
};

export type ModalCreatePackElementProps = {
  onClose?: (props: CloseClbProps) => void;
};

export type ModalCreatePackProps = CommonModalProps<ModalCreatePackElementProps>;

const ModalCreatePack = React.forwardRef<any, ModalCreatePackProps>((props, ref) => {
  const { closeModal, onClose } = props;

  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const enqueueCustomSnackbar = useCustomSnackbar();
  const { t } = useTranslation();

  const [pack, setPack] = useState<DbIngestConfigPackInfos>(() => new DbIngestConfigPackInfos());

  const handleCreate: React.MouseEventHandler = () => {
    if (!openModal) {
      return;
    }

    ingestService
      .CreateConfigPack(pack)
      .then(() => {
        enqueueCustomSnackbar(t("alert:success.newPackCreated"), "success");
        if (onClose) onClose({});
        closeModal();
      })
      .catch((error) => {
        return;
      });
  };

  return (
    <Modal
      title={t("modal:title.createPack")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1.5}>
            <Button onClick={closeModal}>{t("common:cancel")}</Button>
          </Stack>
          <Button
            onClick={handleCreate}
            variant="contained"
            disabled={
              pack === undefined ||
              !pack.name ||
              pack?.name!.length < 3 ||
              !pack.description ||
              pack?.description!.length < 3
            }
          >
            {t("common:create")}
          </Button>
        </Stack>
      }
    >
      <FormControl sx={{ mb: 2 }}>
        <InputLabel shrink htmlFor="packname">
          {t("field:label.packName")}
        </InputLabel>
        <OutlinedInput
          defaultValue=""
          placeholder={t("field:placeholder.packName")}
          id="packname"
          value={pack.name}
          onChange={(e) => setPack({ ...pack, name: e.target.value })}
        />
      </FormControl>
      <FormControl sx={{ mb: 2 }}>
        <InputLabel shrink htmlFor="packdescription">
          {t("field:label.packDescription")}
        </InputLabel>
        <OutlinedInput
          multiline
          rows={4}
          defaultValue=""
          placeholder={t("field:placeholder.packDescription")}
          id="packdescription"
          value={pack.description}
          onChange={(e) => setPack({ ...pack, description: e.target.value })}
        />
      </FormControl>
    </Modal>
  );
});

export default ModalCreatePack;
